//@codekit-prepend "../node_modules/@popperjs/core/dist/umd/popper.js";

coreVariables.popper = {};

coreVariables.popper.show = (el) => {
	el.setAttribute('data-show', '');
}

coreVariables.popper.hide = (el) => {
	el.removeAttribute('data-show');
}

coreVariables.popper.hideAll = () => {

	document.querySelectorAll('.pop').forEach((el) => {

		el.removeAttribute('data-show');

	})

}

//click on the pop-close element
document.querySelectorAll('.pop-close').forEach((el) => {

	el.addEventListener('click', (e) => {

		console.log('click', e.target.parentElement);

		e.target.parentElement.removeAttribute('data-show');

	})

})

//close on body click
document.body.addEventListener('click', (e) => {

	document.querySelectorAll('.pop').forEach((el) => {

		//if the click is on the button itself or the pop, do nothing (otherwise the popper would open then close immediately)
		if (e.target.classList.contains('pop-trigger') || e.target.classList.contains('pop') || jQuery(e.target).parents('.pop').length || jQuery(e.target).parents('.pop-trigger').length) {

			return false;

		} else {

			el.removeAttribute('data-show');

		}

	})

})

/**
 * create the login pop
 * @function
 * @name loginDropDown
 */
coreVariables.loginDropDown = function() {

	const target = document.querySelector('#menu-item-login'),
		pop = document.querySelector('#login-pop');

	if (target && pop && typeof(Popper) !== 'undefined') {

		let settings = {

			placement: 'auto',

		}

		if (coreVariables.viewPortWidth < coreVariables.breakpoints[coreVariables.mobileNavBreakpoint]) {

			settings.placement = 'right';

		}

		coreVariables.loginPop = Popper.createPopper(target, pop, settings);

		target.addEventListener('click', () => {

			// coreVariables.popper.hideAll(); //hide all
			coreVariables.loginPop.update(); //update position
			coreVariables.popper.show(pop); //show

		})

		/* target.on('blur', function(e){

		    pop.toggle();

		}); */

	} else {

		console.warn('CORE: something went wrong with the Popper setup for the login menu');
	}

}